export function toDate(date: Date | string): Date;
export function toDate(date: Date | string | null | undefined): Date | undefined;
export function toDate(date: Date | string | null | undefined): Date | undefined {
  if (date === undefined || date === null) return undefined;
  if (typeof date === 'string') return new Date(date);
  return date;
}

export function toValidDate(date: Date | string | null | undefined): Date | undefined {
  const parsed = toDate(date);
  return parsed && !isNaN(parsed.getTime()) ? parsed : undefined;
}

export function dateToTimeAgoString(date: Date | string): string {
  const dateFrom = toDate(date);
  const dateTo = new Date();
  const diff = dateTo.getTime() - dateFrom.getTime();
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);

  if (hours > 24) {
    return dateFrom.toLocaleDateString();
  } else if (hours > 0) {
    return `vor ${hours} Stunde${hours !== 1 ? 'n' : ''}`;
  } else if (minutes > 0) {
    return `vor ${minutes} Minute${minutes !== 1 ? 'n' : ''}`;
  } else {
    return `vor ${seconds} Sekunde${seconds !== 1 ? 'n' : ''}`;
  }
}

export const toDateString = (date: Date | string): string => {
  if (typeof date == 'string') {
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (dateRegex.test(date)) {
      return date;
    } else {
      date = new Date(date);
      if (isNaN(date.getTime())) {
        throw new Error('Date is not valid!');
      }
    }
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const parseDateString = (value: string): Date => {
  const [year, month, day] = value.split('-').map(Number);
  return new Date(year, month - 1, day);
};

export const isSameDay = (date1?: Date | string, date2?: Date | string): boolean => {
  date1 = toDate(date1);
  date2 = toDate(date2);
  if (date1 === undefined || date2 === undefined) return false;

  return toDateString(date1!) === toDateString(date2!);
};

export function monthNameDe(m: number, style: 'long'|'short'|'narrow' = 'long'): string {
  return new Intl.DateTimeFormat('de-DE', { month: style })
    .format(new Date(2000, m - 1, 1)); // JS months are 0-based
}
